export enum CONTENT_MANAGER_MODELS {
  ZODIAC_TRAIT = 'zodiac-trait',
  GLOSSARY_ENTRY = 'glossary-entry',
  CATEGORY = 'category',
  ZODIAC_COMPATIBILITY = 'zodiac-compatibility',
  BLOG = 'blog',
  COMPETITOR_REVIEW = 'competitor-review',
  GLOSSARY_MAIN_ENTRY = 'glossary-main-entry',
  ADVISOR = 'advisor',
  CHART = 'chart',
  TAROT_GEO = 'tarot-geo',
  GEO = 'geo',
  HOME = 'home',
  NATIVE_APP_MAIN = 'native-app-main',
  PSYCHICS_CATALOGUE = 'psychics-catalogue',
  BLOG_MAIN = 'blog-main',
  ZODIAC_COMPATIBILITY_MAIN = 'zodiac-compatibility-main',
  GEO_MAIN = 'geo-main',
  TAROT_GEO_MAIN = 'tarot-geo-main',
  DAILY_HOROSCOPE_MAIN = 'daily-horoscope-main',
  REVIEWS_MAIN = 'reviews-main',
  FAQ = 'faq',
  BECOME_A_PSYCHIC = 'become-a-psychic',
  CONTACT_US = 'contact-us',
  MEANING = 'meaning',
  PRESS = 'press',
  SIGN_UP_PAGE = 'sign-up-page',
  ZODIAC_TRAITS_MAIN = 'zodiac-traits-main',
  DAILY_HOROSCOPE = 'daily-horoscope',
  ZODIAC_ZODIAC_COMPATIBILITY = 'zodiac-zodiac-compatibility',
}
